/* Vellen Hair Shop v2 (EU, Pipeline) – header, drawer, quick add, product page. Tiers and money format come from data attributes on the header; UI strings from window.vh2Strings (layout). */
(function () {
  'use strict';
  function ready(fn) { if (document.readyState !== 'loading') { fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }
  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  var head, TIERS = [], MONEY = null, closeMenu = function () {};
  var S = window.vh2Strings || {};
  function s(k, d) { return (S[k] !== undefined && S[k] !== null && S[k] !== '') ? S[k] : d; }

  function parseTiers(str) {
    var out = [];
    (str || '').split(',').forEach(function (p) { var a = p.split(':'); var n = parseInt(a[0], 10), d = parseInt(a[1], 10); if (n > 0 && d > 0) { out.push([n, d]); } });
    out.sort(function (a, b) { return a[0] - b[0]; });
    return out;
  }
  function parseMoney(sample) {
    var m = /^(\D*?)(\d[\d.,'’   ]*\d|\d)(\D*)$/.exec(sample || '');
    if (!m) { return { pre: '', suf: ' €', th: '.', dec: ',' }; }
    var num = m[2], dec = num.charAt(num.length - 3), th = num.charAt(1);
    if (/\d/.test(th)) { th = ''; }
    return { pre: m[1], suf: m[3], th: th, dec: dec };
  }
  function money(cents) {
    var f = MONEY || { pre: '', suf: ' €', th: '.', dec: ',' };
    var c = Math.round(cents), neg = c < 0; c = Math.abs(c);
    var i = Math.floor(c / 100).toString(), d = ('0' + (c % 100)).slice(-2);
    if (f.th) { i = i.replace(/\B(?=(\d{3})+(?!\d))/g, f.th); }
    return (neg ? '-' : '') + f.pre + i + f.dec + d + f.suf;
  }
  function tierFor(n) { var t = 0; TIERS.forEach(function (x) { if (n >= x[0]) { t = x[1]; } }); return t; }
  function nextTier(n) { for (var i = 0; i < TIERS.length; i++) { if (n < TIERS[i][0]) { return { at: TIERS[i][0], d: TIERS[i][1] }; } } return null; }
  function barPct(n) {
    var steps = TIERS.length, seg = 100 / steps;
    if (!steps) { return 0; }
    if (n >= TIERS[steps - 1][0]) { return 100; }
    for (var i = 0; i < steps; i++) {
      var from = i === 0 ? 0 : TIERS[i - 1][0], to = TIERS[i][0];
      if (n < to) { return seg * i + seg * Math.max(0, n - from) / (to - from); }
    }
    return 100;
  }
  /* Shopify zieht den Rabatt je Stück ab und rundet ihn ab: Stückpreis = Preis − floor(Preis × Satz), Summe = Stück × Menge */
  function unitAfter(unit, t) { return unit - Math.floor(unit * t / 100); }
  function lineTotal(unit, n) { var t = tierFor(n); return unitAfter(unit, t) * n; }

  /* ---------- Cart (own drawer, reloaded via the Section Rendering API) ---------- */
  function refreshCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      qsa('[data-bind="itemCount"]').forEach(function (el) { el.textContent = c.item_count; });
      return c;
    }).catch(function () { return null; });
  }
  function drawer() { return qs('[data-v2-drawer]'); }
  var lastFocus = null;
  function openDrawer() {
    if (qs('[data-v2-cartform]') || qs('.v2-cartpage')) { window.scrollTo({ top: 0, behavior: 'smooth' }); return true; }
    var d = drawer();
    if (!d) { window.location.href = '/cart'; return false; }
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('v2-lock');
    var c = qs('[data-v2-drawer-close].v2-dr__close', d);
    if (c) { setTimeout(function () { try { c.focus({ preventScroll: true }); } catch (e) {} }, 350); }
    return true;
  }
  function closeDrawer() {
    var d = drawer();
    if (!d || !d.classList.contains('is-open')) { return; }
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('v2-lock');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  function refreshDrawer() {
    var d = drawer();
    if (!d) { return refreshCount(); }
    d.classList.add('is-busy');
    return fetch('/?section_id=vh2-drawer', { headers: { Accept: 'text/html' } }).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = qs('[data-v2-drawer-content]', doc), cur = qs('[data-v2-drawer-content]', d);
      if (fresh && cur) { cur.innerHTML = fresh.innerHTML; }
      d.classList.remove('is-busy');
      var cnt = qs('[data-bind="itemCount"]', d);
      if (cnt) { qsa('[data-bind="itemCount"]').forEach(function (el) { el.textContent = cnt.textContent; }); }
      return true;
    }).catch(function () { d.classList.remove('is-busy'); return refreshCount(); });
  }
  function changeLine(key, qty) {
    var d = drawer(); if (d) { d.classList.add('is-busy'); }
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function () { return refreshDrawer(); });
  }
  function initDrawer() {
    var d = drawer();
    if (!d) { return; }
    d.addEventListener('click', function (e) {
      var t = e.target;
      if (!t.closest) { return; }
      var cl = t.closest('[data-v2-drawer-close]');
      if (cl) { if (cl.tagName !== 'A') { e.preventDefault(); } closeDrawer(); return; }
      var q = t.closest('[data-v2-dqty]');
      if (q) { e.preventDefault(); var inp = qs('[data-v2-dinput="' + q.getAttribute('data-v2-dqty') + '"]', d); var cur = inp ? (parseInt(inp.value, 10) || 0) : 1; changeLine(q.getAttribute('data-v2-dqty'), Math.max(0, cur + (parseInt(q.getAttribute('data-delta'), 10) || 0))); return; }
      var rm = t.closest('[data-v2-dremove]');
      if (rm) { e.preventDefault(); changeLine(rm.getAttribute('data-v2-dremove'), 0); }
    });
    d.addEventListener('change', function (e) {
      var t = e.target;
      if (t.hasAttribute && t.hasAttribute('data-v2-dinput')) { changeLine(t.getAttribute('data-v2-dinput'), Math.max(0, parseInt(t.value, 10) || 0)); }
      if (t.hasAttribute && t.hasAttribute('data-v2-dnote')) { fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: t.value }) }).catch(function () {}); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); } });
    window.addEventListener('pageshow', function (e) { if (e.persisted) { refreshDrawer(); } });
  }
  function addItems(items) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) { throw new Error(j && (j.description || j.message) || s('error', 'Something went wrong')); } return j; }); });
  }
  function addForm(form) {
    return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) { throw new Error(j && (j.description || j.message) || s('error', 'Something went wrong')); } return j; }); });
  }
  function afterAdd() { closeMenu(); refreshDrawer().then(function () { openDrawer(); }); }

  /* ---------- Header ---------- */
  function initHeader() {
    head = qs('[data-v2-head]');
    if (!head) { return; }
    TIERS = parseTiers(head.getAttribute('data-tiers'));
    MONEY = parseMoney(head.getAttribute('data-money'));
    var tick = false;
    function upd() { tick = false; head.classList.toggle('is-scrolled', window.scrollY > 24); }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-v2-cart]') : null;
      if (t) { e.preventDefault(); openDrawer(); }
    });
    var menu = qs('[data-v2-menu]'), lastBtn = null;
    function openMenu(b) {
      if (!menu) { return; }
      lastBtn = b || null;
      menu.classList.add('is-open'); menu.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('v2-lock');
      qsa('[data-v2-menu-open]').forEach(function (x) { x.setAttribute('aria-expanded', 'true'); });
      var c = qs('[data-v2-menu-close]', menu);
      if (c) { setTimeout(function () { try { c.focus({ preventScroll: true }); } catch (e) {} }, 320); }
    }
    closeMenu = function () {
      if (!menu || !menu.classList.contains('is-open')) { return; }
      menu.classList.remove('is-open'); menu.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('v2-lock');
      qsa('[data-v2-menu-open]').forEach(function (x) { x.setAttribute('aria-expanded', 'false'); });
      if (lastBtn) { try { lastBtn.focus({ preventScroll: true }); } catch (e) {} }
      setTimeout(function () { qsa('.v2-menu__grp[open]', menu).forEach(function (o) { o.open = false; }); var body = qs('.v2-menu__body', menu); if (body) { body.scrollTop = 0; } }, 320);
    };
    if (menu) { qsa('.v2-menu__grp', menu).forEach(function (d) { d.addEventListener('toggle', function () { if (d.open) { qsa('.v2-menu__grp', menu).forEach(function (o) { if (o !== d && o.open) { o.open = false; } }); } }); }); }
    qsa('[data-v2-menu-open]').forEach(function (b) { b.addEventListener('click', function () { openMenu(b); }); });
    if (menu) {
      menu.addEventListener('click', function (e) {
        if (e.target === menu || (e.target.closest && e.target.closest('[data-v2-menu-close]'))) { closeMenu(); }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeMenu(); } });
    }
    qsa('[data-v2-country]').forEach(function (sel) { sel.addEventListener('change', function () { if (sel.form) { sel.form.submit(); } }); });
  }

  /* ---------- Quick-Add (Karten, Bestseller) ---------- */
  function initQuickAdd() {
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.hasAttribute || !f.hasAttribute('data-v2-add')) { return; }
      e.preventDefault();
      var btn = qs('button[type=submit]', f);
      if (btn) { btn.disabled = true; }
      addForm(f).then(function () {
        if (btn) { btn.disabled = false; btn.classList.add('is-done'); setTimeout(function () { btn.classList.remove('is-done'); }, 1800); }
        afterAdd();
      }).catch(function (err) {
        if (btn) { btn.disabled = false; }
        var a = f.getAttribute('data-url'); if (a) { window.location.href = a; }
      });
    });
  }

  /* ---------- Mengenpreis-Rechner (Startseite) ---------- */
  function initCalc() {
    var box = qs('[data-v2-calc]');
    if (!box) { return; }
    var unit = parseInt(box.getAttribute('data-price'), 10) || 0, vid = box.getAttribute('data-variant'), name = box.getAttribute('data-name') || '';
    var n = parseInt(box.getAttribute('data-start'), 10) || 3;
    function render() {
      var t = tierFor(n), total = lineTotal(unit, n), nt = nextTier(n);
      qsa('[data-calc-n]', box).forEach(function (b) { var on = parseInt(b.getAttribute('data-calc-n'), 10) === n; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      qs('[data-calc-qty]', box).textContent = n + ' ' + (n === 1 ? s('box_one', 'pop-up box') : s('box_other', 'pop-up boxes'));
      qs('[data-calc-tier]', box).textContent = t ? '−' + t + ' %' : s('single_price', 'Single price');
      qs('[data-calc-total]', box).textContent = money(total);
      qs('[data-calc-unit]', box).textContent = money(unitAfter(unit, t));
      qs('[data-calc-save]', box).textContent = money(unit * n - total);
      qs('[data-calc-bar]', box).style.width = barPct(n) + '%';
      qs('[data-calc-next]', box).textContent = nt ? s('calc_next', '{n} more to −{d} %.').replace('{n}', nt.at - n).replace('{d}', nt.d) : (TIERS.length ? s('calc_top', 'Top tier reached: −{d} % on every box.').replace('{d}', TIERS[TIERS.length - 1][1]) : '');
      qs('[data-calc-cta]', box).textContent = n + ' × ' + name + ' – ' + s('add_to_cart', 'Add to cart') + ' · ' + money(total);
    }
    qsa('[data-calc-n]', box).forEach(function (b) { b.addEventListener('click', function () { n = parseInt(b.getAttribute('data-calc-n'), 10); render(); }); });
    var cta = qs('[data-calc-cta]', box);
    if (cta) {
      cta.addEventListener('click', function () {
        cta.disabled = true;
        addItems([{ id: vid, quantity: n }]).then(function () { cta.disabled = false; afterAdd(); }).catch(function () { cta.disabled = false; window.location.href = box.getAttribute('data-url') || '/'; });
      });
    }
    render();
  }

  /* ---------- Produktseite ---------- */
  function initPdp() {
    var root = qs('[data-v2-pdp]');
    if (!root) { return; }
    var form = qs('[data-v2-form]', root), idInput = form ? qs('input[name="id"]', form) : null, qIn = form ? qs('[data-v2-qinput]', form) : null;
    var cta = qs('[data-v2-cta]', root), err = qs('[data-v2-err]', root);
    var foil = root.getAttribute('data-foil') === 'true';
    var short = root.getAttribute('data-short') || '';
    var data = null; try { data = JSON.parse(qs('[data-v2-json]', root).textContent); } catch (e) {}
    var variants = data ? data.variants : [];
    var cur = null; variants.forEach(function (v) { if (idInput && String(v.id) === String(idInput.value)) { cur = v; } }); if (!cur && variants.length) { cur = variants[0]; }
    var q = 1;

    /* Galerie */
    var track = qs('[data-v2-track]', root), slides = track ? qsa('.v2-gal__slide', track) : [];
    var thumbs = qsa('[data-v2-thumb]', root), dots = qsa('[data-v2-dot]', root);
    function visibleSlides() { return slides.filter(function (s) { return s.offsetParent !== null; }); }
    /* Bilder 2+ nachladen (data-src), erst bei Wischen/Klick oder im Leerlauf nach dem Laden */
    var lazyDone = false;
    function loadSlides() {
      if (lazyDone) { return; } lazyDone = true;
      qsa('img[data-src]', track || root).forEach(function (im) { im.setAttribute('srcset', im.getAttribute('data-srcset') || ''); im.setAttribute('src', im.getAttribute('data-src')); im.removeAttribute('data-src'); im.removeAttribute('data-srcset'); });
    }
    if (track) {
      track.addEventListener('scroll', loadSlides, { passive: true, once: true });
      track.addEventListener('touchstart', loadSlides, { passive: true, once: true });
      track.addEventListener('pointerenter', loadSlides, { once: true });
      window.addEventListener('load', function () { setTimeout(loadSlides, 3000); });
    }
    function goTo(mediaId) {
      var vis = visibleSlides();
      for (var i = 0; i < vis.length; i++) { if (vis[i].getAttribute('data-media') === String(mediaId)) { track.scrollTo({ left: vis[i].offsetLeft, behavior: 'smooth' }); return; } }
    }
    function syncGallery() {
      if (!track) { return; }
      var vis = visibleSlides(), w = track.clientWidth || 1, i = Math.round(track.scrollLeft / w);
      var active = vis[i];
      thumbs.forEach(function (t) { t.classList.toggle('is-on', active && t.getAttribute('data-v2-thumb') === active.getAttribute('data-media')); });
      var tOn = qs('[data-v2-thumb].is-on', root), tRow = tOn && tOn.parentNode;
      if (tRow && tRow.scrollWidth > tRow.clientWidth + 1) { var tL = tOn.getBoundingClientRect().left - tRow.getBoundingClientRect().left + tRow.scrollLeft; if (tL < tRow.scrollLeft || tL + tOn.offsetWidth > tRow.scrollLeft + tRow.clientWidth) { tRow.scrollTo({ left: tL - (tRow.clientWidth - tOn.offsetWidth) / 2, behavior: 'smooth' }); } }
      var vd = dots.filter(function (d) { return d.offsetParent !== null || true; });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      var vid = qs('video', track);
      if (vid) { if (active && active.contains(vid)) { var p = vid.play(); if (p && p.catch) { p.catch(function () {}); } } else { vid.pause(); } }
    }
    if (track) {
      var gt = false;
      track.addEventListener('scroll', function () { if (!gt) { gt = true; requestAnimationFrame(function () { gt = false; syncGallery(); }); } }, { passive: true });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { loadSlides(); goTo(t.getAttribute('data-v2-thumb')); }); });
      function step(d) { loadSlides(); var vis = visibleSlides(), w = track.clientWidth || 1, cur = Math.round(track.scrollLeft / w), k = (cur + d + vis.length) % vis.length; if (vis[k]) { track.scrollTo({ left: vis[k].offsetLeft, behavior: 'smooth' }); } }
      qsa('[data-v2-gprev]', root).forEach(function (b) { b.addEventListener('click', function () { step(-1); }); });
      qsa('[data-v2-gnext]', root).forEach(function (b) { b.addEventListener('click', function () { step(1); }); });
      var vidSlides = qsa('.v2-gal__slide--video', track);
      if (dots.length && vidSlides.length && window.matchMedia('(min-width:799px)').matches) { dots[dots.length - 1].remove(); dots.pop(); }
      setTimeout(syncGallery, 300);
    }

    /* Varianten (Nicht-Folien mit mehreren Varianten) */
    var optGroups = qsa('[data-v2-option]', root);
    function selectedOptions() { return optGroups.map(function (g) { var on = qs('button.is-on', g); return on ? on.getAttribute('data-value') : null; }); }
    function findVariant(opts) { for (var i = 0; i < variants.length; i++) { var v = variants[i], ok = true; for (var k = 0; k < opts.length; k++) { if (opts[k] !== null && v.options[k] !== opts[k]) { ok = false; break; } } if (ok) { return v; } } return null; }
    function markAvailability() {
      optGroups.forEach(function (g, gi) {
        qsa('button', g).forEach(function (b) {
          var opts = selectedOptions(); opts[gi] = b.getAttribute('data-value');
          var v = findVariant(opts); b.classList.toggle('is-na', !v || !v.available);
        });
        var lab = qs('[data-v2-optval]', g.parentNode); var on = qs('button.is-on', g); if (lab && on) { lab.textContent = on.getAttribute('data-value'); }
      });
    }
    optGroups.forEach(function (g) {
      qsa('button', g).forEach(function (b) {
        b.addEventListener('click', function () {
          qsa('button', g).forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-pressed', 'false'); });
          b.classList.add('is-on'); b.setAttribute('aria-pressed', 'true');
          var v = findVariant(selectedOptions());
          if (v) { cur = v; if (idInput) { idInput.value = v.id; } if (v.featured_media && v.featured_media.id) { goTo(v.featured_media.id); } try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); } catch (e) {} }
          markAvailability(); render();
        });
      });
    });
    if (optGroups.length) { markAvailability(); }

    /* Abo-Auswahl */
    function aboChecked() { var r = qs('input[data-radio-type="selling_plan"]:checked', root); return !!r; }
    root.addEventListener('change', function (e) { if (e.target && e.target.getAttribute && e.target.getAttribute('data-radio-type')) { render(); } });

    /* Menge */
    var step = qs('[data-v2-step]', root);
    if (step) {
      qs('[data-v2-dec]', step).addEventListener('click', function () { q = Math.max(1, q - 1); render(); });
      qs('[data-v2-inc]', step).addEventListener('click', function () { q = Math.min(99, q + 1); render(); });
    }

    function render() {
      var unit = cur ? cur.price : 0, avail = cur ? cur.available : false, abo = aboChecked();
      var t = (foil && !abo) ? tierFor(q) : 0, total = unitAfter(unit, t) * q, nt = nextTier(q);
      if (qIn) { qIn.value = q; }
      var set = function (sel, txt) { qsa(sel, root).forEach(function (el) { el.textContent = txt; }); };
      set('[data-v2-q]', q);
      set('[data-v2-unit]', money(unit));
      set('[data-v2-total]', money(total));
      var stock = qs('[data-v2-stock]', root);
      if (stock) { stock.textContent = avail ? s('in_stock', 'In stock') : s('sold_out', 'Sold out'); stock.classList.toggle('is-out', !avail); }
      if (foil && TIERS.length) {
        set('[data-v2-totalnote]', abo ? s('abo_note', 'Subscription · see price above') : (t ? q + ' × ' + money(unitAfter(unit, t)) + ' ' + s('instead_of', 'instead of') + ' ' + money(unit) : s('single_from', 'Single price · from {n} −{d} %').replace('{n}', TIERS[0][0]).replace('{d}', TIERS[0][1])));
        set('[data-v2-tiernote]', t ? s('tier_active', 'Quantity price −{d} % active').replace('{d}', t) : s('tier_from', 'Quantity price from {n}').replace('{n}', TIERS[0][0]));
        var save = qs('[data-v2-save]', root);
        if (save) { if (t) { save.hidden = false; qs('b', save).textContent = money(unit * q - total); } else { save.hidden = true; } }
        var bar = qs('[data-v2-bar]', root); if (bar) { bar.style.width = barPct(q) + '%'; }
        set('[data-v2-next]', nt ? s('tier_next', '{n} more to −{d} %. Counts across all foils in the cart.').replace('{n}', nt.at - q).replace('{d}', nt.d) : s('tier_top', 'Top tier: −{d} %. Counts across all foils in the cart.').replace('{d}', TIERS[TIERS.length - 1][1]));
      } else {
        set('[data-v2-totalnote]', q > 1 ? q + ' × ' + money(unit) : s('incl_vat', 'incl. VAT'));
      }
      if (cta) {
        cta.disabled = !avail;
        cta.textContent = !avail ? s('sold_out', 'Sold out') : (abo ? (q > 1 ? q + ' × ' : '') + s('add_subscription', 'Subscribe and add to cart') : (q > 1 ? q + ' × ' : '') + s('add_to_cart', 'Add to cart') + ' · ' + money(total));
      }
      set('[data-v2-sticky-l]', q + ' × ' + short);
      set('[data-v2-sticky-p]', money(total));
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!cta || cta.disabled) { return; }
        if (err) { err.hidden = true; }
        cta.disabled = true;
        addForm(form).then(function () {
          cta.disabled = false; cta.classList.add('is-done'); setTimeout(function () { cta.classList.remove('is-done'); }, 1800);
          afterAdd();
        }).catch(function (ex) { cta.disabled = false; if (err) { err.textContent = ex.message || s('error', 'That did not work. Please try again.'); err.hidden = false; } });
      });
    }

    /* Sticky-Kaufleiste mobil */
    var sticky = qs('[data-v2-sticky]');
    if (sticky && cta) {
      qs('button', sticky).addEventListener('click', function () { if (form.requestSubmit) { form.requestSubmit(); } else { cta.click(); } });
      var st = false;
      function sUpd() { st = false; var r = cta.getBoundingClientRect(); var on = r.bottom < 0 && window.innerWidth < 799; sticky.classList.toggle('is-on', on); document.body.classList.toggle('v2-has-sticky', on); }
      window.addEventListener('scroll', function () { if (!st) { st = true; requestAnimationFrame(sUpd); } }, { passive: true });
      window.addEventListener('resize', sUpd); sUpd();
    }
    render();
  }

  /* ---------- Produktkarten: Bildwechsel wie Framar (Pfeile, beim Überfahren Bild 2). Bild 2 wird vorgeladen, sobald die Karte in die Nähe des Sichtfensters kommt, und erst eingeschoben, wenn es geladen ist – sonst sähe man kurz nur die graue Fläche. ---------- */
  function initCards() {
    var io = null;
    if (window.IntersectionObserver) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { io.unobserve(en.target); if (en.target.__v2pre) { en.target.__v2pre(); } } });
      }, { rootMargin: '240px 0px' });
    }
    function swap(im) {
      if (!im || !im.hasAttribute('data-src')) { return; }
      im.setAttribute('srcset', im.getAttribute('data-srcset') || ''); im.setAttribute('src', im.getAttribute('data-src'));
      im.removeAttribute('data-src'); im.removeAttribute('data-srcset');
    }
    qsa('[data-v2-slides]').forEach(function (box) {
      var track = qs('[data-v2-track]', box); if (!track) { return; }
      var n = track.children.length, i = 0, loaded = false, fromHover = false, hovering = false;
      if (n < 2) { return; }
      var second = qs('img', track.children[1]);
      box.__v2pre = function () { swap(second); };
      if (io) { io.observe(box); } else { swap(second); }
      function load() { if (loaded) { return; } loaded = true; qsa('img[data-src]', track).forEach(swap); }
      function go(k) { i = (k + n) % n; track.style.transform = 'translateX(-' + (i * 100) + '%)'; }
      function showSecond() {
        if (!second) { go(1); return; }
        swap(second);
        if (second.complete && second.naturalWidth > 0) { go(1); return; }
        second.addEventListener('load', function () { if (hovering && i === 0) { fromHover = true; go(1); } }, { once: true });
      }
      var prev = qs('[data-v2-prev]', box), next = qs('[data-v2-next]', box);
      if (prev) { prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); load(); fromHover = false; go(i - 1); }); }
      if (next) { next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); load(); fromHover = false; go(i + 1); }); }
      box.addEventListener('pointerenter', function (e) { if (e.pointerType && e.pointerType !== 'mouse') { return; } hovering = true; load(); if (i === 0) { fromHover = true; showSecond(); } });
      box.addEventListener('pointerleave', function (e) { if (e.pointerType && e.pointerType !== 'mouse') { return; } hovering = false; if (fromHover) { fromHover = false; go(0); } });
      box.addEventListener('touchstart', load, { passive: true, once: true });
    });
  }

  /* ---------- Kollektion: Sortierung ---------- */
  function initSort() {
    qsa('[data-v2-sort]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        try { var u = new URL(window.location.href); u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page'); window.location.href = u.toString(); } catch (e) {}
      });
    });
  }

  /* ---------- Warenkorb-Seite: Stepper schickt das Formular ab ---------- */
  function initCartPage() {
    var form = qs('[data-v2-cartform]');
    if (!form) { return; }
    function send(inp, delta) { var v = Math.max(0, (parseInt(inp.value, 10) || 0) + delta); inp.value = v; form.submit(); }
    form.addEventListener('click', function (e) {
      var dec = e.target.closest ? e.target.closest('[data-v2-cdec]') : null, inc = e.target.closest ? e.target.closest('[data-v2-cinc]') : null;
      if (dec) { send(qs('[data-v2-cqty]', dec.parentNode), -1); }
      if (inc) { send(qs('[data-v2-cqty]', inc.parentNode), 1); }
    });
    form.addEventListener('change', function (e) { if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-v2-cqty')) { form.submit(); } });
  }

  ready(function () { initHeader(); initDrawer(); initQuickAdd(); initCalc(); initPdp(); initCards(); initSort(); initCartPage(); });
})();
